<script setup>
import { ref } from "vue";
import Layout from "../../Components/Shared/LayoutAdmin.vue";
import TableItem from "../../Components/Shared/TableItem.vue";
import { Link } from "@inertiajs/inertia-vue3";
import ModalComponent from "../../Components/Shared/ModalComponent.vue";
import ButtonComponent from "../../Components/Shared/ButtonComponent.vue";
import BlogForm from "../../Components/Forms/BlogForm.vue";
import { Inertia } from "@inertiajs/inertia";
import HeaderAdminComponent from "../../Components/Shared/HeaderAdminComponent.vue";

import useNotification from "../../Services/useNotification";
import useApi from "../../Services/useApi";

const props = defineProps(["posts"]);
let modalShow = ref(false)
let modalTitle = ref('Crear')
const notificate = useNotification()
const api = useApi()

const initBlog = {
    title: "",
    excerpt: "",
    content: "",
};
const blogToCreate = ref(initBlog);
const create = ()=>{
    modalShow.value = true;
}

const edit = (blog)=>{
    blogToCreate.value = blog
    modalTitle.value = 'Editar'
    modalShow.value = true;
}

const remove = (blog)=>{
    notificate.confirm("Seguro que quieres eliminar este post ?",()=>{
        api.deleteBlog(blog).then((response) => {
            console.log(response);
            notificate.success("Eliminado!");
            Inertia.reload();
        });
    })
}

const resetModal = () => {
    modalShow.value = false;
};
</script>
<template lang="">
    <Layout>
        <HeaderAdminComponent title="Blog"></HeaderAdminComponent>

        <div class="container mx-auto my-14 px-10">
        <ButtonComponent 
            content="Atrás" 
            :icon="'arrow_back_ios'"
            :link="'/admin'"
            type="2"
        />
        <ButtonComponent 
            content="Añadir nuevo post" 
            :icon="null"
            :link="null"
            type="0"
            @click="create" 
            />
        <div class="flex w-full" v-for="item in props.posts" :key="item.id">
            <Link class="w-full" :href="'/category/'+item.id+'/fruits'">
                <TableItem :items="[
                    { key: 'id', name: 'ID',value:item.id , width: '10%' },
                    { key: 'title', title: 'Titulo',value:item.title , width: '30%' },
                    { key: 'excerpt', name: 'Resumen',value:item.excerpt , width: '30%' },
                    { key: 'content', name: 'Contenido',value:item.content , width: '30%' },
                ]" /> 
            </Link>
            <div class="w-20 ml-6" v-if="$page.props.isAdmin==true">
                <div class="flex pt-10">
                    <img class="w-5 mx-2 transform cursor-pointer hover:scale-90 " src="/images/editar_enriqueto.svg" v-on:click="edit(item)" alt="">
                    <img class="w-5 mx-2 transform cursor-pointer hover:scale-90 " src="/images/borrar_enriqueto.svg" v-on:click="remove(item)" alt="">
                </div>
            </div>
        </div>
        </div>
        <ModalComponent
            :title="modalTitle + ' Blog'"
            v-model="modalShow"
            v-if="modalShow"
        >
            <BlogForm @added="resetModal" :blog="blogToCreate"></BlogForm>
        </ModalComponent>
    </Layout>
</template>
<style lang="">
    
</style>